import { Component, Input } from '@angular/core';

@Component({
  selector: 'uex-layout-header',
  templateUrl: './header.component.html',
  host: {
    class: 'uex-layout-header'
  }
})
export class LayoutHeaderComponent {
  @Input('alignItems') public alignItems = 'center';
  @Input('alignContent') public alignContent: string = null;
  @Input('justifyItems') public justifyItems: string = null;

  constructor() { }
}
